import { usePathname } from 'next/navigation';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

export const useLoginGuard = () => {
  const myInfo = useAuthStore((state) => state.myInfo);
  const pathname = usePathname();
  const router = useCustomRouter();

  const loginGuard = () => {
    if (!myInfo) {
      router.replace(
        ROUTES.LOGIN.withSearchParams({
          searchParams: { redirect: pathname ?? '' },
        }),
      );

      return false;
    }

    return true;
  };

  return loginGuard;
};
